// extracted by mini-css-extract-plugin
module.exports = {"header":"Section_header__gnXlq","wrapper":"Section_wrapper__1THWV","cardWrapper":"Section_cardWrapper__3zfeG","toggleText":"Section_toggleText__3TlA9"};